import type { PropsWithChildren } from 'react';
import { useContext } from 'react';

import type { UserType } from '@/api/user/UserType.ts';
import { userContext } from '@/context/UserContext.tsx';

type Props = PropsWithChildren<{
  allow:
    | UserType // for convenience
    | [UserType, UserType, ...UserType[]]; // at least two elements
  // the case for three elements is purely theoretical since there is only 3 user types for now
  // for now using all three user type values in 'allow' is like allowing everyone, which is useless
}>;

export function UsertypeGuard({ allow, children }: Props) {
  const context = useContext(userContext);

  if (!context) {
    return null;
  }

  const _allow = Array.isArray(allow) ? allow : [allow];

  return _allow.includes(context.currentUser.userType) ? children : null;
}
